var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#92D700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0098 46.7679C26.0532 47.3202 25.7254 48.5434 26.2777 49.5C26.83 50.4566 28.0532 50.7843 29.0098 50.2321L27.0098 46.7679ZM55.9224 34.0176C56.2083 32.9507 55.5751 31.854 54.5082 31.5681L37.1215 26.9094C36.0546 26.6235 34.9579 27.2567 34.672 28.3236C34.3861 29.3906 35.0193 30.4872 36.0862 30.7731L51.541 34.9142L47.3999 50.369C47.1141 51.436 47.7472 52.5326 48.8141 52.8185C49.8811 53.1044 50.9778 52.4712 51.2636 51.4043L55.9224 34.0176ZM29.0098 50.2321L54.9905 35.232L52.9905 31.7679L27.0098 46.7679L29.0098 50.2321Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.3a711c7c99ff466faf20a90a7ecd3f73.svg";
export { ForwardRef as ReactComponent };